import axios from "axios"
import authHeader from "./auth-header"

const API_URL = 'https://api.kairosmining.com/api'
const API_URLCIOE = 'https://api.kairosmining.com/api'

const getPublicContent = () => {
  return axios.get(API_URL + "all")
}

const getDataN1 = (body, url) => {
  return axios.post(API_URL + url, body, { headers: authHeader() })
}

const getDataN1CIOE = (body) => {
  return axios.post(API_URLCIOE + "/cioe/getDataN1", body, { headers: authHeader() })
}

const updateDataTostacionDMH = (body) => {
  return axios.post(API_URL + '/Tostacion/updateValoresTostacion', body, { headers: authHeader() })
}

const getDataTostacionDMH2 = (body) => {
  // console.log(API_URL + '/Tostacion/getValoresTostacion')
  return axios.post(API_URL + '/Tostacion/getValoresTostacion', body, { headers: authHeader() })
}

const postTostacionUpload = (body) => {
  return axios.post(API_URL + '/upload', body, { headers: authHeader() })
}

const getTostacionModeloDomo = (body) => {
  return axios.post(API_URL + '/Tostacion/getModeloDomoTostacion', body, { headers: authHeader() })
}


const exportedObject = {
  getPublicContent,
  getDataN1,
  getDataN1CIOE,
  getDataTostacionDMH2,
  postTostacionUpload,
  updateDataTostacionDMH,
  getTostacionModeloDomo
}

export default exportedObject